import React, { useState, useEffect, useContext } from "react";
import { useSelector } from "react-redux";
import { AppSyncContext } from "../contexts/AppSyncContext";
import { Chat } from "@fluentui/react-northstar";
import { Button } from "@fluentui/react-northstar";

export const Transcribe = () => {
  const { unsubscribe, transcriptions, activeTranscription, subscribedCalls } =
    useContext(AppSyncContext);
  const [chatItems, setChatItems] = useState([]);
  const [isCondensed, setIsCondensed] = useState(true);

  const call = subscribedCalls.get(activeTranscription);
  console.error("subscribed calls:", subscribedCalls);
  console.error("call", call);

  useEffect(() => {
    generateItems(activeTranscription);
    console.error("transcription changed");
  }, [transcriptions, activeTranscription, isCondensed]);

  const condense = (transcription) => {
    const result = [];

    // to avoid condensing incorrectly
    // if we get a message with multiple speakers
    // we will always print them separately
    let lastWasMultiSpeaker = false;

    for (const group of transcription) {
      if (group.length > 1) {
        // Multiple speakers in this group — do not condense, just push each
        for (const message of group) {
          result.push({ ...message });
        }
        lastWasMultiSpeaker = true;
      } else {
        const message = group[0]; // we only have one speaker
        const last = result[result.length - 1];

        if (!lastWasMultiSpeaker && last && last.speaker === message.speaker) {
          last.transcription += message.transcription;
        } else {
          result.push({ ...message });
        }

        lastWasMultiSpeaker = false;
      }
    }

    return result;
  };

  const generateItems = (activeTranscription) => {
    if (transcriptions.size > 0) {
      const transcription = transcriptions.get(activeTranscription) ?? [];
      //const transcriptionToUse = isCondensed ? condense(transcription) : transcription.flat();
      //console.error({ transcription, condensedTranscription: transcriptionToUse });

      console.error("original transcription:", transcription);
      const items = transcription.map((message, messageIndex) => ({
        message: (
          <Chat.Message
            content={message.transcription}
            author={`speaker`}
          />
        ),
        contentPosition: "start",
        attached: "top",
        key: `${messageIndex}`,
      }));

      console.error("setting chat items", items);
      setChatItems(items);
    }
  };

  return (
    <>
      {call ? (
        <div className="d-flex flex-column bd-highlight full-height">
          <div className="d-flex flex-row justify-content-between">
            <div className="d-flex flex-row align-items-center">
              <h1>Transcribing Call</h1>
            </div>
            <div className="d-flex flex-row align-items-center">
              {/* <Button
                primary
                content={isCondensed ? "Show Original" : "Show Condensed"}
                onClick={() => setIsCondensed(!isCondensed)}
                style={{ marginRight: "1rem" }}
              /> */}
              <h1>
                Between {call.dnumber} and {call.snumber}
              </h1>
            </div>
          </div>
          <div className="flex-grow-1 overflow-auto mb-3">
            <Chat items={chatItems} />
          </div>
        </div>
      ) : (
        // no active transcription
        <div className="d-flex flex-column bd-highlight full-height align-items-center justify-content-center">
          <h1>
            There are no active transcriptions.
            <br />
            To transcribe a call press the "Transcribe" button on an active
            call, on the main page.
          </h1>
        </div>
      )}
    </>
  );
};
